<template>
  <div class="Login">
    <!-- <div class="imgs"></div>
		<div class="trans"></div> -->
    <video
      src="@/assets/image/login_bg01.mp4"
      autoplay
      muted
      loop
      preload="auto"
    ></video>
    <div class="form">
      <img class="form-img" src="../assets/image/logo.png" alt="" />
      <div class="title">建德市桥梁监测系统</div>
      <img src="../assets/image/login-line.png" alt="" class="line" />
      <!-- <el-divider>桥隧安全</el-divider> -->
      <el-form class="loginForm" :model="form" :rules="rules" ref="form">
        <el-form-item prop="userName">
          <el-input
            placeholder="请输入用户名"
            v-model="form.userName"
            clearable
          >
            <template #prefix>
              <img src="../assets/image/icon-user.png" />
            </template>
          </el-input>
        </el-form-item>
        <el-form-item prop="passWord">
          <el-input
            type="password"
            placeholder="请输入密码"
            v-model="form.passWord"
            clearable
          >
            <template #prefix>
              <img src="../assets/image/icon-pwd.png" />
            </template>
          </el-input>
        </el-form-item>
        <el-form-item
          ><el-button class="login-btn" @click="Login"></el-button
        ></el-form-item>
        <!-- <el-checkbox v-model="checked" checked class="remember">记住用户名</el-checkbox> -->
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  data() {
    return {
      form: {},
      rules: {
        userName: [
          {
            required: true,
            message: '请输入用户名',
            trigger: 'blur'
          }
        ],
        passWord: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {},
  components: {},

  mounted() {},
  methods: {
    ...mapMutations(['SET_USER', 'editUserInfo', 'editMenus', 'editBackBut']),
    get(val) {
      let obj = {
        1: '2',
        2: '3'
      }
      this.num = obj.val
    },
    //登录
    Login() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let md5 = require('js-md5')
          //  this.form.passWord = md5.hex(this.form.passWord)
          let form = {
            password: md5.hex(this.form.passWord),
            accountNum: this.form.userName
          }
          const res = await this.$api.sendPost('/accountInfo/login', form)
          if (res.errcode === 0) {
            sessionStorage.setItem('token', res.data.token)
            sessionStorage.setItem('userInfo', JSON.stringify(res.data))
            this.SET_USER(res.data)
            this.editUserInfo(res.data)
            this.editBackBut(1)
            if (res.data.menus) {
              res.data.menus.map((item) => {
                item.icon = item.icon
                  ? require(`@/assets/image/${item.icon}.png`)
                  : ''
                // item.childMenu.map(item => {
                //   if (item.id === 232 || item.id === 372) {
                //     item.disabled = true;
                //   } else {
                //     item.disabled = false;
                //   }
                // })
              })
            }
            this.editMenus(res.data.menus)
            this.$router.push('/layout')
          } else {
            this.$message.warning(res.errmsg)
          }
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.Login {
  width: 100%;
  height: 100%;
  background: url('~@/assets/image/login_bg.png') center center;
  // background-image: linear-gradient(to right, #0d7981, #02313c);
  background-size: cover;
  position: relative;

  // .trans {
  // 	position: absolute;
  // 	width: 584px;
  // 	height: 432px;
  // 	background: url('~@/assets/image/donghua.png');
  // 	background-size: 100% 100%;
  // 	left: 266px;
  // 	top: 330px;
  // 	animation: movepoint 5s ease-in-out;
  // 	animation-iteration-count: infinite;
  // }

  // @keyframes movepoint {
  // 	0% {
  // 		top: 330px;
  // 	}

  // 	50% {
  // 		top: 280px;
  // 	}

  // 	100% {
  // 		top: 330px;
  // 	}
  // }

  // .imgs {
  // 	width: 100%;
  // 	height: 100%;
  // 	background: url('~@/assets/image/tuceng1.png');
  // 	background-size: 100% 100%;
  // }
  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: fill;
  }
  .form {
    width: 480px;
    height: 560px;
    position: absolute;
    top: 268px;
    right: 296px;
    background: url('~@/assets/image/login_form.png') center center;
    background-size: cover;
    // box-shadow: 0px 4px 8px 4px rgba(0, 0, 0, 0.3);
    padding: 10px 50px 70px;
    box-sizing: border-box;
    // border-radius: 4px;
    .form-img {
      width: 168px;
      height: 76px;
      margin-top: 20px;
    }
    .title {
      margin-top: 10px;
      margin-bottom: 0;
      font-size: 38px;
      font-weight: 800;
      // font-family: YouSheBiaoTiHei;
      color: #fff;
    }

    .loginForm {
      margin-top: 80px;
    }

    .login-btn {
      margin-top: 20px;
      width: 210px;
      height: 77px;
      background: url('~@/assets/image/login-btn.png') no-repeat;
      background-size: contain;
      color: white;
      border: none;
      font-size: 16px;
    }
    .line {
      position: absolute;
      right: 0;
      width: 135px;
      right: 70px;
    }
  }
}

::v-deep .el-input__inner {
  border: none;
  background: transparent !important;
  border-bottom: 1px solid #368ae8;
  padding-left: 32px;
  padding-bottom: 10rpx;
  color: #fff;
  border-radius: 0;
  &::placeholder {
    color: #fff;
  }
}

::v-deep .el-form-item {
  margin-bottom: 30px;
}

::v-deep .el-input__icon {
  font-size: 16px;
  color: white;
}

::v-deep .el-divider__text {
  color: #0e6a77;
}
::v-deep .el-input__prefix {
  img {
    width: 22px;
    height: 22px;
  }
}
::v-deep input:-webkit-autofill {
  -webkit-text-fill-color: white !important;
}
.el-divider--horizontal {
  height: 1px;
  width: 75%;
  margin-left: 13%;
}

//下划线
.el-divider {
  background: #0e6a77;
}
</style>
